import { faker } from '@faker-js/faker';

import type { VerifyMfaTokenPostResponse } from '../types/VerifyMfaTokenPostResponse';

export function createVerifyMfaTokenPostResponse(
  data: NonNullable<Partial<VerifyMfaTokenPostResponse>> = {}
): NonNullable<VerifyMfaTokenPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
